import { Tag, Text, Tooltip } from '@chakra-ui/react';

type Props = {
  name: string;
};

export default function CaseClusterTag({ name }: Props) {
  return (
    <Tag ml={2} colorScheme="gray">
      <Tooltip label={name}>
        <Text textOverflow="ellipsis" noOfLines={1}>
          {name}
        </Text>
      </Tooltip>
    </Tag>
  );
}
